import { getSlug } from "../header";

export function dataHeader() {
	const location = window.location;
	const dataHeader = document.getElementById("dataHeader");

	const isDataStorePage =
		getSlug(location) === "data-store" ||
		location.pathname.startsWith("/data-store/");

	if (!dataHeader) {
		return null;
	}

	const links = dataHeader.querySelectorAll("a");

	if (isDataStorePage) {
		links[1].classList.add("active");
	} else {
		links[0].classList.add("active");
	}
}
